import {configureStore} from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import authReducer from './Reducers/auth'
import loadingReducer from './Reducers/loading'
import commonReducer from './Reducers/common'
export const store = configureStore({
    reducer:{
        auth:authReducer,
        loading:loadingReducer,
        common:commonReducer
    },
   
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

setupListeners(store.dispatch)
